/**
 * Hold competitions state
 */
import { ILeaderboard } from '@kattana-io/common';
import {
  SET_COMPETITION_WALLET,
  REFRESH_COMPETITION,
  SET_LEADERBOARD,
} from '../actions/competition';

export interface ICompetitionState {
  wallet?: string;
  refresh: number;
  leaderboard: ILeaderboard[];
}

const defaultState: ICompetitionState = { refresh: 0, leaderboard: [] };

const competition = (
  state: ICompetitionState = defaultState,
  action: any
): ICompetitionState => {
  switch (action.type) {
  case SET_COMPETITION_WALLET:
    return {
      ...state,
      wallet: action.payload,
    };
  case REFRESH_COMPETITION:
    return {
      ...state,
      refresh: state.refresh + 1,
    };
  case SET_LEADERBOARD:
    return {
      ...state,
      leaderboard: action.payload,
    };
  default:
    return state;
  }
};

export default competition;
